export default [
  {
    title: "Single Function Adapter",
    items: [
      {
        name: "b1",
        src: require("@/assets/images/adapters/b1-dub.jpg"),
        info: [],
      },
      {
        name: "tl-5",
        src: require("@/assets/images/adapters/tl-2-dub.jpg"),
        info: [],
      },
      {
        name: "tl4a",
        src: require("@/assets/images/adapters/tl4a-dub.jpg"),
        info: [],
      },
      {
        name: "pt-3",
        src: require("@/assets/images/adapters/pt-3-dub.jpg"),
        info: [],
      },
      {
        name: "ph-3",
        src: require("@/assets/images/adapters/ph-3-dub.jpg"),
        info: [],
      },
      {
        name: "ml",
        src: require("@/assets/images/adapters/ml-dub.jpg"),
        info: [],
      },
      {
        name: "tlc",
        src: require("@/assets/images/adapters/tlc-dub.jpg"),
        info: [],
      },
      {
        name: "a3",
        src: require("@/assets/images/adapters/a3.jpg"),
        info: [],
      },
      {
        name: "pl",
        src: require("@/assets/images/adapters/pl-dub.jpg"),
        info: [],
      },
      {
        name: "cl+cl-r",
        src: require("@/assets/images/adapters/cl+cl-r-dub.jpg"),
        info: [],
      },
      {
        name: "bl-2a",
        src: require("@/assets/images/adapters/bl-2a-dub.jpg"),
        info: [],
      },
      {
        name: "tl-b",
        src: require("@/assets/images/adapters/pt-r-dub.jpg"),
        info: [],
      },
    ],
  },
  {
    title: "Multifunction Adapter",
    items: [
      {
        name: "m3",
        info: [],
        src: require("@/assets/images/adapters/m3.jpg"),
      },
      {
        name: "m4",
        info: [],
        src: require("@/assets/images/adapters/m4.jpg"),
      },
    ],
  },
];